export const formatDecimalNumber = (value) => {
  if (typeof value === "number" || !isNaN(Number(value))) {
    value = Number(value);
    return Number.isInteger(value) ? value.toString() : value.toFixed(2);
  }
  return "NaN";
};
